import React from "react";
import { spring, interpolate, useCurrentFrame, useVideoConfig } from "remotion";

export interface BentoItemProps {
  children: React.ReactNode;
  delay?: number;
  active?: boolean;
  activeBorderColor?: string;
  defaultBorderColor?: string;
  bgColor?: string;
  style?: React.CSSProperties;
}

/**
 * BentoItem Component
 * Kartu modular bento dengan spring entrance, blur background, dan dynamic active glow border.
 */
export const BentoItem: React.FC<BentoItemProps> = ({
  children,
  delay = 0,
  active = false,
  activeBorderColor = "#e8f36e",
  defaultBorderColor = "rgba(255,255,255,0.12)",
  bgColor = "rgba(20, 26, 23, 0.85)",
  style,
}) => {
  const frame = useCurrentFrame();
  const { fps } = useVideoConfig();

  const entrance = spring({
    frame: frame - delay,
    fps,
    config: { damping: 15, stiffness: 150 },
  });

  const translateY = interpolate(entrance, [0, 1], [30, 0]);

  return (
    <div
      style={{
        backgroundColor: bgColor,
        border: active ? `2px solid ${activeBorderColor}` : `1px solid ${defaultBorderColor}`,
        borderRadius: "20px",
        padding: "24px 28px",
        transform: `translateY(${translateY}px) scale(${active ? 1.02 : 1})`,
        opacity: entrance,
        backdropFilter: "blur(20px)",
        boxShadow: active
          ? `0 10px 30px ${activeBorderColor}26`
          : "none",
        transition: "transform 0.2s ease, border 0.2s ease",
        ...style,
      }}
    >
      {children}
    </div>
  );
};
